export type ManagerialDashboardAccess = {
  expires_on: string
}

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export function parseManagerialDashboardAccess(
  value: unknown
): ManagerialDashboardAccess | null {
  if (!isRecord(value)) return null
  if (typeof value.expires_on !== 'string' || !ISO_DATE_PATTERN.test(value.expires_on)) {
    return null
  }
  return { expires_on: value.expires_on }
}

export function extractManagerialDashboardAccessFromMe(
  response: unknown
): ManagerialDashboardAccess | null {
  if (!isRecord(response) || response.success !== true || !isRecord(response.data)) {
    return null
  }
  if (response.data.collaborator) {
    return null
  }
  return parseManagerialDashboardAccess(response.data.managerial_dashboard_access)
}

export function formatShareExpiresOn(date: string): string {
  const [year, month, day] = date.split('-')
  if (!year || !month || !day) return date
  return `${day}/${month}/${year}`
}
